import { InfoCircleOutlined } from '@ant-design/icons';
import { List, Space, Switch, Table, Tooltip } from 'antd';
import { payPeriodApi } from 'Api/payPeriod';
import Ellipse from 'components/Global/Ellipse';
import { createContext } from 'react';
import { useSelector } from 'react-redux';
import { formatDate, toastText } from 'utils/utils';
const { Column } = Table;

type Props = {
	payPeriodLatestData: any;
	isLoading: boolean;
	tableChangeHandler: (pagination: any, filter: any, sorter: any) => void;
	currencies: any;
};
export const PermissionContext = createContext<any>({
	permissions: null,
	companyId: null,
	userId: null,
});

const PayPeriodTable = (props: Props) => {
	const {
		payPeriodLatestData,
		isLoading,
		tableChangeHandler,
		currencies,
	} = props;

	const { data: profileData } = useSelector(
		(state: any) => state?.userProfile
	);

	const statusHandler = async (value: any, data: any) => {
		const finalData: any = {
			payPeriodId: data?.id,
			status: value,
		};

		try {
			await payPeriodApi.updatePayPeriodStatus(finalData);
			toastText('Status updated successfully', 'success');
		} catch (error: any) {
			let message =
				error?.response?.data?.message ||
				`Something went wrong in status update`;
			toastText(message, 'error');
		}
	};

	
	const monthlyStatusHandler = async (value: any, data: any) => {
		const finalData: any = {
			payPeriodId: data?.id,
			status: value,
		};

		try {
			await payPeriodApi.updatePayPeriodMonthlyLogStatus(finalData);
			toastText('Monthly timelogs status updated successfully', 'success');
		} catch (error: any) {
			let message =
				error?.response?.data?.message ||
				`Something went wrong in status update`;
			toastText(message, 'error');
		}
	};

	return (
		<div>
			<Table
				dataSource={payPeriodLatestData}
				pagination={false}
				onChange={tableChangeHandler}
				rowKey={(record) => record.id}
				scroll={{ y: 'calc(100vh - 320px)' }}
				loading={isLoading}
			>
				<Column
					title="Pay Period"
					dataIndex="name"
					key="name"
					className="bg-white"
					width={'25%'}
					render={(text: string, record: { id: string }) => {
						return (
							<Ellipse
								message={text}
								maxLength={35}
								key={record.id}
								tooltipMessage={text}
								isTooltip={true}
							/>
						);
					}}
				/>
				<Column
					title="Start Date"
					dataIndex="startDate"
					key="startDate"
					className="bg-white"
					width={'14%'}
					render={(value) => {
						return formatDate(
							value,
							profileData?.companyDateFormat ?? 'DD/MM/YYYY'
						);
					}}
					sorter={true}
				/>
				<Column
					title="End Date"
					dataIndex="endDate"
					key="endDate"
					width={'14%'}
					className="bg-white"
					render={(value) => {
						return formatDate(
							value,
							profileData?.companyDateFormat ?? 'DD/MM/YYYY'
						);
					}}
					sorter={true}
				/>
				<Column
					title="Exchange Rate"
					dataIndex="name"
					key="name"
					align="center"
					className="bg-white"
					width={'18%'}
					render={(_, record: any) => {
						return (
							<div
								style={{
									display: 'flex',
									gap: '10px',
									justifyContent: 'center',
									alignItems: 'center',
								}}
							>
								{record.PayPeriodCurrency.length > 0 ? (
									<div>
										<Tooltip
											title={
												<div
													style={{
														padding: '8px 4px',
													}}
												>
													<p
														style={{
															color: '#1890ff',
															display: 'block',
														}}
													>
														Exchange Rates
													</p>
													<List
														size="small"
														dataSource={
															record.PayPeriodCurrency
														}
														style={{
															backgroundColor:
																'white',
															maxWidth: 250,
														}}
														renderItem={(
															ppc: any
														) => {
															const currency =
																currencies.find(
																	(c: any) =>
																		c.companyCurrencyId ===
																		ppc.companyCurrencyId
																);
															return (
																<List.Item
																	key={ppc.id}
																	style={{
																		padding:
																			'6px 0',
																		backgroundColor:
																			'white',
																		borderBottom:
																			'1px solid #f0f0f0',
																	}}
																>
																	<div
																		style={{
																			display:
																				'flex',
																			justifyContent:
																				'space-between',
																			width: '100%',
																		}}
																	>
																		<p
																			style={{
																				fontSize:
																					'14px',
																			}}
																		>
																			1{' '}
																			{currency
																				? currency.currency
																				: ''}{' '}
																			{
																				'='
																			}{' '}
																		</p>
																		<p
																			style={{
																				fontSize:
																					'14px',
																			}}
																		>
																			{
																				ppc.conversionRate
																			}{' '}
																			Kwacha
																		</p>
																	</div>
																</List.Item>
															);
														}}
													/>
												</div>
											}
											placement="top"
											color="white"
										>
											<span
												style={{
													color: '#1890ff',
													cursor: 'pointer',
													fontWeight: 500,
													fontSize: '14px',
												}}
											>
												View Rates
											</span>
										</Tooltip>
									</div>
								) : (
									<>{'-'}</>
								)}
							</div>
						);
					}}
				/>
				<Column
					title={
						<span>
							<b>Hourly Logs Source </b>
							<Tooltip
								title="Indicates whether the hourly logs is from system or imported"
								placement="top"
							>
								<InfoCircleOutlined
									style={{ marginLeft: 4, color: '#584495' }}
								/>
							</Tooltip>
						</span>
					}
					dataIndex="isImportedSheetData"
					key="isImportedSheetData"
					className="bg-white"
					width={'15%'}
					render={(value: any, data: any) => {
						return (
							<div
								style={{
									display: 'flex',
									justifyContent: 'center',
									alignItems: 'center',
								}}
							>
								<Space>
									{data.isDisabled ? (
										<Tooltip title="Source is locked — payroll finalized or approved for this period.">
											<Switch
												key={data.name}
												defaultChecked={value}
												disabled={data.isDisabled}
												onChange={(e) =>
													statusHandler(e, data)
												}
											/>
										</Tooltip>
									) : (
										<Switch
											key={data.name}
											defaultChecked={value}
											disabled={data.isDisabled}
											onChange={(e) =>
												statusHandler(e, data)
											}
										/>
									)}
								</Space>
							</div>
						);
					}}
				/>
				<Column
					title={
						<span>
							<b>Monthly Logs Source </b>
							<Tooltip
								title="Indicates whether the monthly logs is from system or imported"
								placement="top"
							>
								<InfoCircleOutlined
									style={{ marginLeft: 4, color: '#584495' }}
								/>
							</Tooltip>
						</span>
					}
					dataIndex="isMonthlyImport"
					key="isMonthlyImport"
					className="bg-white"
					width={'15%'}
					render={(value: any, data: any) => {
						return (
							<div
								style={{
									display: 'flex',
									justifyContent: 'center',
									alignItems: 'center',
								}}
							>
								<Space>
									{data.isDisabled ? (
										<Tooltip title="Source is locked — payroll finalized or approved for this period.">
											<Switch
												key={data.name}
												defaultChecked={value}
												disabled={data.isDisabled}
												onChange={(e) =>
													monthlyStatusHandler(
														e,
														data
													)
												}
											/>
										</Tooltip>
									) : (
										<Switch
											key={data.name}
											defaultChecked={value}
											disabled={data.isDisabled}
											onChange={(e) =>
												monthlyStatusHandler(e, data)
											}
										/>
									)}
								</Space>
							</div>
						);
					}}
				/>
			</Table>
		</div>
	);
};

export default PayPeriodTable;

